import { useMutation, useQueryClient, type UseMutationOptions } from '@tanstack/react-query';
import { PGCandidateOrderEntity, PGCorpCandidateOrderPayload } from '@wolfejs/ms-api-js/src/types/orders';
import { useMsClient } from '@wolfejs/ms-api-react/src/contexts';
import { buildOptions } from '@wolfejs/ms-api-react/src/utils/buildOptions';
import { createCandidateOrder } from './api';

/**
 * A candidate order in PG corp IS the cart. A new candidate order is created every time a user edits items in their "cart".
 * Used to create a new candidate order - a new candidate order is created if new items are added to the cart, items are deleted, etc.
 */
export const usePGCorpCreateCandidateOrder = (
  options?: UseMutationOptions<PGCandidateOrderEntity, Error, PGCorpCandidateOrderPayload>
) => {
  const { client } = useMsClient();
  const queryClient = useQueryClient();
  const key = 'createCandidateOrder';

  return useMutation<PGCandidateOrderEntity, Error, PGCorpCandidateOrderPayload>(
    (payload: PGCorpCandidateOrderPayload) => createCandidateOrder(client, payload),
    buildOptions(queryClient, [key, 'detail'], options)
  );
};
